import { DateTime } from 'luxon';
import { TTimerFormat } from '../types/types';
import i18n from '../../assets/i18n';

export const formatTime = (value: number) => {
  if (value < 10 && value >= 0) {
    return `0${value}`;
  }

  return value;
};

export const calculateTimeLeft = (
  targetDate?: string | null,
  format?: TTimerFormat,
) => {
  if (!targetDate) {
    return null;
  }

  const now = DateTime.utc();
  const target = DateTime.fromISO(targetDate, { zone: 'utc' });
  const diff = target
    .diff(now, ['days', 'hours', 'minutes', 'seconds'])
    .toObject();

  const days = Math.max(0, Math.floor(diff.days || 0));
  const hours = Math.max(0, Math.floor(diff.hours || 0));
  const mins = Math.max(0, Math.floor(diff.minutes || 0));
  const sec = Math.max(0, Math.floor(diff.seconds || 0));

  if (days <= 0 && hours <= 0 && mins <= 0 && sec <= 0) {
    return null;
  }
  switch (format) {
    case 'SHORT_DATE':
      return `${days}d ${formatTime(hours)}h ${formatTime(mins)}m ${formatTime(sec)}s`;
    case 'SHORT_TIME':
      return `${formatTime(hours)}:${formatTime(mins)}:${formatTime(sec)}`;
    case 'TIME':
      return `${formatTime(hours)} hours ${formatTime(mins)} mins ${formatTime(sec)} sec`;
    case 'SECONDS':
      return `${sec}`;
    case 'DAYS_OR_TIME':
      return days > 0
        ? `${i18n.t('common.days', { value: days })}`
        : `${formatTime(hours)}:${formatTime(mins)}:${formatTime(sec)}`;
    default:
      return `${days} days ${formatTime(hours)} hours ${formatTime(mins)} mins ${formatTime(sec)} sec`;
  }
};

export const getTomorrowDate = () =>
  DateTime.now().setZone('CET').plus({ days: 1 }).startOf('day').toISO();
